import { createSlice } from '@reduxjs/toolkit'
import { getCookie } from '../../lib/other';


interface AuthState {
  value: boolean
}

const initialState: AuthState = {
  value: window.localStorage.getItem('isLogined') === "true" && getCookie("AuthStatus") ? true : false
}


export const counterSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    login: (state) => {
      state.value = true;
      window.localStorage.setItem('isLogined', state.value.toString());
    },
    logout: (state) => {
      state.value = false;
      window.localStorage.setItem('isLogined', state.value.toString());
    },
  },
})


export const { login, logout } = counterSlice.actions

// Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.auth.value

export default counterSlice.reducer
